export const radius = {
    none: '0',
    extraSmall: '4px',
    small: '8px',
    medium: '12px',
    normal: '16px',
    large: '24px',
    extraLarge: '32px',
    full: '1000px',
} as const

export type Radius = typeof radius
